module.exports = __webpack_public_path__ + "assets/media/gradient-arrow.d52dae22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Deal/PlanSummary/gradient-arrow.svg
// module id = 2693
// module chunks = 0